const LoadingButton = Vue.component('loading-button', {
  name: 'LoadingButton',
  props: {
    inProgress: {
      type: Boolean,
      required: true
    },
    text: {
        type: String,
        required: true
    },
    loadingText:{
        type: String,
        default: 'Loading...',
    },
  },


  methods: {
    /**
     * While in progress the button stays focusable (aria-disabled rather than
     * disabled, which would drop keyboard focus to the page), so the click
     * is cancelled here instead. preventDefault also stops a form submitting
     * twice via Enter.
     *
     * @param {MouseEvent} event
     */
    onClick(event){
        if (this.inProgress) {
            event.preventDefault()
            return
        }
        this.$emit('click')
    }
  },


  // The visible loading text is aria-hidden and the status span carries it
  // instead, so it is announced once and is the button's name while busy.
  template: /* html */ `
    <button @click="onClick" :aria-disabled="inProgress ? 'true' : null" :class="{ disabled: inProgress }" class="btn">
        <span class="visually-hidden" role="status">{{ inProgress ? loadingText : '' }}</span>
        <div v-show="inProgress" aria-hidden="true">
          <i  class='fa fa-spinner fa-spin me-2 '></i>
          <span> {{ loadingText }}</span>
        </div>
        <div v-show="!inProgress">
          {{ text }}
          <slot></slot>
        </div>
    </button>
  `,
})
